import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider, useData } from './lib/DataContext.jsx';
import Sidebar from './components/shell/Sidebar.jsx';
import Topbar from './components/shell/Topbar.jsx';
import FilterBar from './components/shell/FilterBar.jsx';

import Overview from './pages/Overview.jsx';
import ParameterScoring from './pages/ParameterScoring.jsx';
import OecdAnalysis from './pages/OecdAnalysis.jsx';
import Geography from './pages/Geography.jsx';
import Partners from './pages/Partners.jsx';
import RegionalZonal from './pages/RegionalZonal.jsx';
import InterventionBudget from './pages/InterventionBudget.jsx';
import DataHealth from './pages/DataHealth.jsx';
import ReachImpact from './pages/ReachImpact.jsx';
import Goals from './pages/Goals.jsx';
import SdgAlignment from './pages/SdgAlignment.jsx';
import ResultsChain from './pages/ResultsChain.jsx';
import CostOfOutcome from './pages/CostOfOutcome.jsx';
import Simulator from './pages/Simulator.jsx';
import BeneficiaryModal from './components/ui/BeneficiaryModal.jsx';
import ChatPanel from './components/ui/ChatPanel.jsx';

function Shell() {
  const { data, error, openProject, setOpenProject } = useData();

  if (error) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'var(--accent-2)', fontSize: 14, padding: 40,
      }} data-testid="app-error">
        Failed to load data: {error}
      </div>
    );
  }

  return (
    <div className="app-grid">
      <Sidebar />
      <div style={{ minWidth: 0 }}>
        <Topbar />
        <FilterBar />
        <main style={{ minHeight: 'calc(100vh - 60px - 60px)' }}>
          {!data ? (
            <div style={{
              padding: 40, color: 'var(--ink-3)', fontSize: 14,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }} data-testid="app-loading">
              Loading Parivartan data…
            </div>
          ) : (
            <div className="fade-up">
              <Routes>
                <Route path="/" element={<Navigate to="/overview" replace />} />
                <Route path="/overview" element={<Overview />} />
                <Route path="/param" element={<ParameterScoring />} />
                <Route path="/oecd" element={<OecdAnalysis />} />
                <Route path="/geo" element={<Geography />} />
                <Route path="/partner" element={<Partners />} />
                <Route path="/region" element={<RegionalZonal />} />
                <Route path="/budget" element={<InterventionBudget />} />
                <Route path="/cost" element={<CostOfOutcome />} />
                <Route path="/simulator" element={<Simulator />} />
                <Route path="/results" element={<ResultsChain />} />
                <Route path="/health" element={<DataHealth />} />
                <Route path="/reach" element={<ReachImpact />} />
                <Route path="/goals" element={<Goals />} />
                <Route path="/sdg" element={<SdgAlignment />} />
                <Route path="*" element={<Navigate to="/overview" replace />} />
              </Routes>
            </div>
          )}
        </main>
      </div>
      {openProject && <BeneficiaryModal code={openProject} onClose={() => setOpenProject(null)} />}
      <ChatPanel />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <DataProvider>
        <Shell />
      </DataProvider>
    </BrowserRouter>
  );
}

export default App;
